export default "__VITE_ASSET__CIIlQjHH__"